import { RouterView } from "vue-router";
import { ProjectRouting } from "./project/project.routing";
import { TeamRouting } from "./team/team.routing";
import { GuaranteeAgreementRouting } from "./guarantee-agreement/guarantee-agreement.routing";
import { WarrantyWorkOrderCenterRouting } from "./warrantyWorkOrderCenter/warrantyWorkOrderCenter.routing";
import { AutoDispatchRouting } from "./autoDispatch/autoDispatch.routing";
import { MyWarrantyRouting } from "./myWarranty/myWarranty.routing";
import { EarlyWarningRouting } from "./early-warning/early-warning.routing";
import { OperationAgreementRouting } from "./operation-agreement/operation-agreement.routing";
import { MyOperationRouting } from "./myOperation/myOperation.routing";
import { OperationWorkOrderCenterRouting } from "./operationWorkOrderCenter/operationWorkOrderCenter.routing";

export const MaintenanceRouting = {
  path: "/maintenance",
  name: "maintenance",
  redirect: "/maintenance/project",
  component: RouterView,
  meta: { title: "维保管理", icon: "weibao" },
  children: [
    ...ProjectRouting,
    ...TeamRouting,
    ...GuaranteeAgreementRouting,
    ...WarrantyWorkOrderCenterRouting,
    ...AutoDispatchRouting,
    ...MyWarrantyRouting,
    ...EarlyWarningRouting,
    ...OperationAgreementRouting,
    ...MyOperationRouting,
    ...OperationWorkOrderCenterRouting
  ],
};
